import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-baozhuang",
  "use": "icon-baozhuang-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-baozhuang\"><path fill=\"\" d=\"M905.6 236.6L522.1 65.8c-6.2-2.8-13.2-2.8-19.4-0.1L118.3 234.6c-8.7 3.8-14.3 12.5-14.3 22v511.2c0 9.6 5.7 18.2 14.4 22L502.6 957c3.1 1.3 6.3 2 9.6 2s6.5-0.7 9.6-2l383.7-167.2c8.8-3.8 14.4-12.5 14.4-22V258.6c-0.1-9.5-5.6-18.1-14.3-22zM514.7 115l322.9 143.8-130.8 66.5L393.7 166l116.1-51c1.6-0.7 3.3-0.6 4.9 0z m-2.6 309.3L184 258.2 337 191l316.8 161.3-141.7 72zM151.9 295.7L488.2 466v432.4L155.5 753.6c-2.2-1-3.6-3.1-3.6-5.5V295.7z m384.3 602.6V465.9l335.7-170.7v452.9c0 2.4-1.4 4.5-3.6 5.5L536.2 898.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/baozhuang.svg
// module id = WTYB
// module chunks = 67